<template>
  <v-footer color="primary">
    <v-col
      class="text-right"
      cols="12"
    >
      v{{ $root.appVersion }} © Copyright {{ year }} RealSAM Ltd. All rights reserved.
    </v-col>
  </v-footer>
</template>

<script>

export default {
  data: function () {
    return {
        year: new Date().getFullYear(),
        company: "",
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
  .v-footer {
    margin-top:auto; 
    font-size: 0.8em;
  }
</style>